"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const CardGroup = (0, react_1.forwardRef)(({ children, className, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsx)("div", { ref: ref, className: (0, uswds_react_utils_1.createClassString)('usa-card-group', className), ...props, children: children }));
});
exports.default = CardGroup;
